import { Callout, PageContainer } from "@/components/ui"
import { useStorefrontScheduling } from "@/hooks/use-storefront-scheduling"

/**
 * Explains why a closed store still takes orders (§2A.5). Each ordering
 * surface mounts it below its own header: the home after the whole store
 * header block, the bag and the checkout right under their top bar. Mounted
 * from the router it sat under the fixed header. Renders nothing when there
 * is nothing to say.
 */
export function SchedulingBanner() {
  const { banner } = useStorefrontScheduling()
  if (!banner) return null

  return (
    <PageContainer className="my-2">
      <Callout tone="info">{banner}</Callout>
    </PageContainer>
  )
}

export default SchedulingBanner
